import React, { useEffect, useState } from 'react';
import { Input, Label } from '~/componentes/CustomForm';

import { Container, SecaoTicket, ItemTicket } from './styles';
import { Materialize } from '~/styles/materializeGrid';

const statusFixos = {
  A: { cor: '#dee54d' },
  C: { cor: '#76BD3E' },
  T: { cor: '#6796CF' },
  R: { cor: '#e68282' },
  S: { cor: '#e68282' },
  E: { cor: '#707070' },
};

function formatarMinutosMascara(totalMinutos) {
  const minutos = parseFloat(totalMinutos || 0);
  const horas = parseInt(minutos / 60);
  const resto = Math.round(minutos % 60);
  return ('00' + horas).slice(-2) + ':' + ('00' + resto).slice(-2);
}

function CreateContent({ mountedData }) {
  const isSuporte = mountedData?.tipoOS === 'S';
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    if (!isSuporte) {
      setTickets([]);
      return;
    }

    let thisTickets = [];
    for (const atividade of mountedData?.atividades ?? []) {
      for (const tarefa of atividade?.tarefas ?? []) {
        const isComplementar =
          !tarefa?.ticket || !tarefa?.ticketInteracao || tarefa?.titulo === 'Atividade SRP';

        thisTickets.push({
          tipo: isComplementar ? 'M' : 'A',
          idTicket: tarefa?.idTicket,
          titulo: tarefa?.titulo,
          cliente: tarefa?.ticket?.nomeCliente || 'ERPWorks',
          idMovidesk: tarefa?.ticket?.idMoviDesk,
          idMovideskAction: tarefa?.ticketInteracao?.idMoviDesk,
          description: tarefa?.descricao,
          htmlDescription: tarefa?.descricaoHtml,
          totalHora: tarefa?.horaTotalMascara,
          totalHoraMinutos: tarefa?.horaTotalMinuto,
          posHorario: !!tarefa?.posHorario,
          excluido: !!tarefa?.excluido,
          horarios: tarefa?.horarios ?? [],
        });
      }
    }

    setTickets(thisTickets);
  }, [mountedData, isSuporte]);

  const totalHorasLancadas = formatarMinutosMascara(
    tickets
      .filter(item => !item?.excluido)
      .reduce((soma, item) => soma + parseFloat(item?.totalHoraMinutos || 0), 0),
  );
  const totalAtividadeSRP = formatarMinutosMascara(
    tickets
      .filter(item => item?.tipo === 'M' && !item?.excluido)
      .reduce((soma, item) => soma + parseFloat(item?.totalHoraMinutos || 0), 0),
  );
  const totalPosHorario = formatarMinutosMascara(
    tickets
      .filter(item => item?.posHorario && !item?.excluido)
      .reduce((soma, item) => soma + parseFloat(item?.totalHoraMinutos || 0), 0),
  );

  return (
    <Container defaultScroll={true}>
      <Materialize className="materialize">
        <div className="aprov-header row no-margin">
          <div className="aprov-title">
            <span className="aprov-cod">#{mountedData?.id}</span>
            <h3>{mountedData?.titulo}</h3>
            <span
              className={`badge-tipo ${isSuporte ? 'badge-tipo-suporte' : 'badge-tipo-projeto'}`}
            >
              {isSuporte ? 'Suporte' : 'Projeto'}
            </span>
          </div>
          <span
            className="badge-status"
            style={{ borderColor: statusFixos[mountedData?.statusAprovacao]?.cor }}
          >
            {mountedData?.descricaoStatusAprov}
          </span>
        </div>

        <div className="aprov-info-grid row no-margin">
          {isSuporte ? (
            <>
              <div className="info-item">
                <span className="info-label">Analista</span>
                <span className="info-value">{mountedData?.analista?.nome}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Coordenador</span>
                <span className="info-value">{mountedData?.coordenador?.nome}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Cliente</span>
                <span className="info-value">{mountedData?.cliente?.nomeFantasia}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Projeto</span>
                <span className="info-value">{mountedData?.projeto?.titulo}</span>
              </div>
            </>
          ) : (
            <>
              <div className="info-item">
                <span className="info-label">Cliente</span>
                <span className="info-value">{mountedData?.cliente?.nomeFantasia}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Projeto</span>
                <span className="info-value">{mountedData?.projeto?.titulo}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Coordenador</span>
                <span className="info-value">{mountedData?.coordenador?.nome}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Analista</span>
                <span className="info-value">{mountedData?.analista?.nome}</span>
              </div>
            </>
          )}
        </div>

        <div className="aprov-info-grid row no-margin">
          <div className="info-item">
            <span className="info-label">Emissão</span>
            <span className="info-value">
              {
                new Date(mountedData?.dataEmissao)
                  .toLocaleString('pt-BR', { timeZone: 'UTC' })
                  .split(',')[0]
              }
            </span>
          </div>
          <div className="info-item">
            <span className="info-label">Hora Translado</span>
            <span className="info-value">{mountedData?.horaTransladoMacara}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Hora Desconto</span>
            <span className="info-value">{mountedData?.horaDescontoMascara}</span>
          </div>
          {!isSuporte && (
            <div className="info-item info-item-destaque">
              <span className="info-label">Total de Horas Lançadas</span>
              <span className="info-value">{mountedData?.horaTotalMascara}</span>
            </div>
          )}
        </div>

        {isSuporte && (
          <div className="aprov-stats row no-margin">
            <div className="stat-card">
              <p className="stat-label">SRP Autorizado</p>
              <p className="stat-value">{totalPosHorario}</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">Atividade SRP</p>
              <p className="stat-value">{totalAtividadeSRP}</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">Total de Horas</p>
              <p className="stat-value">{totalHorasLancadas}</p>
            </div>
          </div>
        )}

        {mountedData?.observacao && (
          <div className="row no-margin">
            <div className="item col s12 m12 l12">
              <h5>Observação: </h5>
              <p>{mountedData?.observacao}</p>
            </div>
          </div>
        )}

        {isSuporte ? (
          <div className="row">
            <div className="col s12 m12 l12">
              <div className="content-top col s12 m12 l12">
                <p className="title_p">Atividades</p>
              </div>
              <div className="col s12 m12 l12">
                <ItemTicket item={false}>
                  <div className="col s1 m1 l2">
                    <p className="text-col">Id</p>
                  </div>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Sq</p>
                  </div>
                  <div className="col s3 m3 l3">
                    <p className="text-col">Cliente</p>
                  </div>
                  <div className="col s5 m5 l5">
                    <p className="text-col">Titulo Ticket</p>
                  </div>
                  <div className="col s2 m2 l1">
                    <p className="text-col" style={{ textAlign: 'right', width: '100%' }}>
                      Total
                    </p>
                  </div>
                </ItemTicket>
                <div className="content-atividade">
                  {tickets?.map((item, index) => (
                    <SecaoTicket key={index} excluido={item?.excluido}>
                      <ItemTicket
                        item={true}
                        excluido={item?.excluido}
                        onClick={() => {
                          setTickets(
                            tickets.map((itemTicket, itemIndex) =>
                              itemIndex === index
                                ? { ...itemTicket, check: !itemTicket?.check }
                                : itemTicket,
                            ),
                          );
                        }}
                      >
                        <div className="col s1 m1 l2">
                          <p className="text-col">
                            {item?.idMovidesk ? `#${item?.idMovidesk}` : '-'}
                          </p>
                        </div>
                        <div className="col s1 m1 l1">
                          <p className="text-col">{item?.idMovideskAction || '-'}</p>
                        </div>
                        <div className="col s4 m4 l3">
                          <p className="text-col">{item?.cliente}</p>
                        </div>
                        <div className="col s5 m5 l5">
                          <p className="text-col titulo-com-badge">
                            {item?.titulo}
                            {item?.tipo === 'M' && <span className="badge-srp">SRP</span>}
                            {item?.posHorario && <span className="badge-pos">SRP Autorizado</span>}
                          </p>
                        </div>
                        <div className="col s2 m2 l1">
                          <p className="text-col" style={{ textAlign: 'right', width: '100%' }}>
                            {item?.totalHora}
                          </p>
                        </div>
                      </ItemTicket>
                      {item?.check == true && (
                        <div className="atv-content-body">
                          <div className="col s12 m6 l6">
                            <p
                              className={item?.htmlDescription ? 'item-desc' : 'item-desc no-html'}
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item?.htmlDescription
                                    ? item?.htmlDescription
                                    : item?.description,
                                }}
                              ></div>
                            </p>
                          </div>
                          <div className="col s12 m6 l6">
                            {item?.horarios?.map((itemHorario, indexHorario) => (
                              <div className="item-horario" key={indexHorario}>
                                <div className="row">
                                  <Label title="Inicial" className="col s6 m6 l6">
                                    <Input
                                      type="time"
                                      name="horaInicial"
                                      disabled="true"
                                      value={itemHorario?.horaInicialMascara}
                                      style={{ fontSize: '0.9em' }}
                                    />
                                  </Label>
                                  <Label title="Final" className="col s6 m6 l6">
                                    <Input
                                      type="time"
                                      name="horaFinal"
                                      disabled="true"
                                      value={itemHorario?.horaFinalMascara}
                                      style={{ fontSize: '0.9em' }}
                                    />
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </SecaoTicket>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="row no-margin">
              <p className="title_p">Horários Lançados</p>
              <div className="horario">
                {mountedData?.horarios?.map((thisHora, a) => (
                  <div className="item-hora" key={a}>
                    <div className="card-numero">
                      <p className="numero">{a + 1}</p>
                    </div>
                    <div className="card-hora">
                      <p className="hora">
                        {thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="row no-margin">
              <div className="col s12 m12 l12 no-padding">
                <p className="title_p">Atividades</p>
                {mountedData?.atividades?.map((thisAtividade, a) => (
                  <div className="row col s12 m12 l12" key={a}>
                    <div className="row item lateral no-margin">
                      <h5>Atividade: </h5>
                      <p>{thisAtividade?.titulo}</p>
                    </div>
                    <div className="row item no-margin">
                      <h5>Descrição </h5>
                      <p>{thisAtividade?.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </Materialize>
    </Container>
  );
}

export default CreateContent;
